import * as React from "react";

import { LOADING, asUI } from "common/components/types";
import { GlideFunctionalRenderer } from "common/components/uis";
import SimpleList from "../ui/views/simple-list/simple-list";
import { ColumnStyle } from "common/generator/components/column-style";
import { styled, blurBehindMixin } from "../styled-components";
import { useForce } from "hooks/use-force";
import { useForceValueProducers } from "hooks/use-value-producers";

const BottomContainer = styled.div`
    position: sticky;
    bottom: calc(var(--bottom-bar-padding) + var(--safe-area-inset-bottom));

    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    & > .content-region {
        background-color: ${p => p.theme.primaryOverlayColor};

        ${p => blurBehindMixin({ backgroundColor: p.theme.transparentOverlayColor })}

        border-top: solid 1px ${p => p.theme.separatorColor};

        padding-top: 8px;
    }
`;

export const ColumnMaterialRenderer: GlideFunctionalRenderer = p => {
    const { env, getValueProducers, ctx } = p;
    const [force] = useForce();
    const [[, styleValue, ...items]] = useForceValueProducers(getValueProducers, force, ctx);

    let result: React.ReactElement;
    result = (
        <SimpleList items={items}>
            {(v, i) => {
                if (v === LOADING) return <React.Fragment key={i}>{env.renderProgress()}</React.Fragment>;
                if (v === undefined) return undefined;
                return <React.Fragment key={i}>{asUI(v).render(ctx, env)}</React.Fragment>;
            }}
        </SimpleList>
    );

    if (styleValue === ColumnStyle.Bottom) {
        result = (
            <BottomContainer>
                <div className="content-region">{result}</div>
            </BottomContainer>
        );
    }

    return result;
};
